import { Link } from "react-router";
import { getBrowseStats } from "#app/utils/word.server.ts";
import { type Route } from "./+types/browse.ts";

export async function loader() {
  const stats = await getBrowseStats();
  return { stats };
}

export const meta: Route.MetaFunction = () => [
  { title: "Browse Words by Letter - shonaslang" },
  { name: "description", content: "Browse Shona slang words alphabetically" },
];

export default function BrowsePage({ loaderData }: Route.ComponentProps) {
  const { stats } = loaderData;
  const alphabet = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "#",
  ];

  return (
    <div className="container mx-auto max-w-4xl px-4 py-8">
      <div className="mb-8 text-center">
        <h1 className="mb-4 text-h1 text-foreground">Browse by Letter</h1>
        <p className="text-body-lg text-muted-foreground">
          Explore {stats.totalWords} Shona slang words organized alphabetically
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {alphabet.map((letter) => {
          const count = stats.letterCounts[letter] || 0;
          const featuredWords = stats.featuredWords[letter] || [];

          return (
            <Link
              key={letter}
              to={`/browse/${letter.toLowerCase()}`}
              className="group rounded-lg border border-border bg-card p-6 transition-colors hover:border-blue-200 hover:bg-blue-50/50 dark:hover:bg-blue-950/20"
            >
              <div className="mb-4 flex items-center justify-between">
                <h2 className="text-2xl font-bold text-card-foreground group-hover:text-blue-600">
                  {letter}
                </h2>
                <span className="text-sm text-muted-foreground">
                  {count} {count === 1 ? "word" : "words"}
                </span>
              </div>

              {featuredWords.length > 0 && (
                <div className="space-y-2">
                  {featuredWords.slice(0, 3).map((word) => (
                    <div key={word.id} className="text-sm">
                      <span className="font-medium text-card-foreground">
                        {word.definitions[0]?.definitionShona}
                      </span>
                      <span className="ml-2 text-muted-foreground">
                        {word.definitions[0]?.translationEn}
                      </span>
                    </div>
                  ))}
                  {count > 3 && (
                    <div className="text-xs text-muted-foreground">
                      +{count - 3} more
                    </div>
                  )}
                </div>
              )}

              {count === 0 && (
                <p className="text-sm text-muted-foreground italic">
                  No words yet
                </p>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
